import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';

export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => { const h = () => setScrolled(window.scrollY > 30); window.addEventListener('scroll', h, { passive: true }); return () => window.removeEventListener('scroll', h); }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 transition-all bg-[#050505] border-b ${scrolled ? 'border-[#F8F4ED]/15 py-3' : 'border-transparent py-5'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 grid grid-cols-[1fr_auto_1fr] items-center gap-6">
        <div className="hidden md:block font-mono text-[10px] tracking-[0.4em] uppercase text-[#F8F4ED]/55">— Issue 12 · Spring XXVI</div>
        <button onClick={() => setPage('home')} data-testid="mh-logo" className="text-center"><p className="font-serif italic text-[28px] leading-none text-[#F8F4ED]">{META.brand}</p><p className="font-mono text-[8px] tracking-[0.55em] uppercase text-[#F8F4ED]/55 mt-1">— Photographer —</p></button>
        <nav className="hidden md:flex items-center justify-end gap-7">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`mh-nav-${r.id}`} className={`group flex items-baseline gap-1.5 transition-colors ${page === r.id ? 'text-[#A33A3A]' : 'text-[#F8F4ED]/65 hover:text-[#F8F4ED]'}`}>
              <span className="font-mono text-[9px] tracking-[0.32em] opacity-50 group-hover:opacity-100">{r.no}</span>
              <span className="font-serif italic text-base">{r.label}</span>
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}
